import { defineMessages } from 'react-intl'

export default defineMessages({
  logOutModalTitle: {
    id: 'logOutModal.title',
    defaultMessage: 'You will be logged out.',
  },
  logOutModalBody: {
    id: 'logOutModal.body',
    defaultMessage: 'Do you wish to continue?',
  },
  logOutBtn: {
    id: 'logOutModal.logOutBtn',
    defaultMessage: 'Yes, log out',
  },
  cancelBtn: {
    id: 'logOutModal.cancelBtn',
    defaultMessage: 'Cancel',
  },
})
